import { lazy } from 'react';

export const LessonScreenLazy = lazy(async () => {
  const { LessonScreen } = await import('./lesson.screen.tsx');
  return { default: LessonScreen };
});
